import React from 'react'
import Table from 'react-bootstrap/Table';
import Navbars from '../../MinutesPage/Navbars'
import Container from 'react-bootstrap/Container';
import image3 from '../../image/constitution-image4.jpg'
import imageMap from '../../image/map.PNG'
/* import Gallary from './Pages/Gallary';
 */
export const Constitution = () => {
  return (
    
 
    
<div className=' cons-tables relative top-0' style={{marginTop:'-2rem'}}>
{<Navbars />}
<Container className='relative top-36'>
    <div className="row" style={{boxShadow:'rgba(0, 0, 0, 0.24) 0px 3px 8px;'}}>
      <div className="col-md-6 text-dark  ">
      <img src={image3} alt="" className="src-image fluid" 
      />
      </div>
      <div className="col-md-6 text-dark" >
      <img src={imageMap} alt="" className="src-map fluid" 
       style={{ 
       borderBottomLeftRadius:'40%',
       borderBottomRightRadius:'40%'
       }}/>
      </div>
    </div>
  </Container>

    
{    <hr className="horrizontal relative top-10" 
        style={{
        border: '1px solid rgba(98, 97, 97, 0.9)', 
        margin:'5rem 0'
      }}
     />}


<Container className='relative top-20'>
<div className='PDF-cover pt-5 pr-48 pl-4'>
    <div className="row">
    <caption style={{minWidth:'300px'}}><strong>TABLE OF CONTENT</strong></caption>

<Table style={{width:'100%'}} >

<tbody>
<tr>
<td  colSpan={5}><strong>Subjects</strong></td>
<td><strong>Page</strong></td>
</tr>
<tr>
<td colSpan={5}> Contents</td>
<td><strong>1</strong></td>
</tr>

<tr>
<td colSpan={5}>Introduction/ A glance at Igbo</td>
<td><strong>2</strong></td>
</tr>
<tr>
<td colSpan={5}>Introduction/ Title</td>
<td><strong>3</strong></td>
</tr>
<tr>
<td colSpan={5}>Preamble and purpose of Constitution</td>
<td><strong>3</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 1 - membership</strong></td>
<td><strong>4</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 2 - Registration and dues</strong></td>
<td><strong>4</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 3 - Officers of the association</strong></td>
<td><strong>5-7</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 4 - Election of officers</strong></td>
<td><strong>7-8</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 5 - Terms of office</strong></td>
<td><strong>8-9</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 6 - Vacancy and registration</strong></td>
<td><strong>10</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 7 - Committe of the association</strong></td>
<td><strong>10-11</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 8 - Meetings</strong></td>
<td><strong>11-12</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 9 - Quorum</strong></td>
<td><strong>12</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 10 - Finance</strong></td>
<td><strong>13-14</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 11 - Expenditure</strong></td>
<td><strong>14-16</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 12 - Right and privileges</strong></td>
<td><strong>16</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 13 - Debt settlement</strong></td>
<td><strong>16-17</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 14 - Displine</strong></td>
<td><strong>18</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 15 - Censure and judgement</strong></td>
<td><strong>18</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 16 - Affilliation with other associtions</strong></td>
<td><strong>19</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 17 - Policy </strong></td>
<td><strong>19</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 18 - Dissolution/windup </strong></td>
<td><strong>20</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 19 - Constitution amendment </strong></td>
<td><strong>20</strong></td>
</tr>
<tr>
<td className='no-border' colSpan={5}><strong>Article 20 - Philanthropic activities</strong></td>
<td><strong></strong></td>
</tr>
<tr>
<td colSpan={5}>Witness</td>
<td><strong>21</strong></td>
</tr>
<tr>
<td colSpan={5}>Acknowledgement</td>
<td><strong>21</strong></td>
</tr>
</tbody>
</Table>
    </div>
    </div>
  </Container>



  <Container className='relative top-32'>
    <div className="row">

    <div className='constitution-tabl text-dark'
     style={{maxWidth:'45rem'}}>
   <div className='page-header'
   style={{minWidth:'100%'}}>
<strong><h4>Igbo Cultural Association, Northwest Ireland</h4></strong>

{'('}<span style={{fontSize:'1.rem', paddingBottom:'5px'}}>Nzuko ndigbo</span>{')'}<br/>
<span className=' text-green-500'><h5>CONSTITUTION</h5></span><br/>
</div>

<p><u><b>PREAMBLE</b></u></p>
The Ibo Association of Donegal is a socio-cultural, non-profit organization. Literally, the word 'lbo' represents the ethnic group while Igbo represents the group's language. However the words 'lbo' and "Igbo' are often used interchangeably,<br/><br/>

<p><u><b>PURPOSE</b></u></p>
<b>The purpose(s) of the society is (are):</b><br/>
<b className='me-2'>a.</b>	 To foster unity among the Ibos and other ethnic groups within and<br/>
<b className='me-2'>b.</b>		outside the Province of County Donegal and its environ<br/>
<b className='me-2'>c.</b>	 to promote and maintain the social, educational, cultural, civic, and general well-being of its members and to provide a forum for social, educational and cultural exchange between the Ibo people and other associations.<br/>
<b className='me-2'>d.</b>		To educate the youth about their Igbo cultural and linguistic heritage<br/>
<b className='me-2'>e.</b>		To promote academic and sports excellence by providing scholarships and other awards to deserving youth members<br/>
<b className='me-2'>f.</b>		To enhance the image of the Igbo speaking people of Nigeria in association with other ethnic groups within and outside the Province of County Donegal and its environ through public relations, staging of seminars on topical issues and disseminating information on matters of mutual interest.<br/>
<b className='me-2'>g.</b>		To identify economically disadvantaged individuals or groups here in County Donegal and its environ or in Ibo land and render them financial assistance from time to time.
 

</div>

      
    </div>
  </Container>

  {    <hr className="horrizontal2" 
        style={{
        marginTop: '1rem', 
   
        borderTop: '1px solid rgba(0, 0, 0, 0.9)'}}
        />}

  <Container className='relative top-36'>
    <div className="row">
      
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}>ARTICLE 1</b></u><br/><br/>
<b>Membership</b><br/>
<b>Section I:</b><br></br>
<b>Membership </b> - Membership shall be open to all Ibos resident in County Donegal and its environ and will be extended to individuals who qualify under the provisions of Section I, II and III(under membership) of the constitution.<br/><br/>



<strong><h6>Section II:</h6></strong>
<b>Types of Membership shall be by</b><br/>
<b className='me-2'>a. Birth - </b>Any Ibo person resident in County Donegal and its environ<br/>
<b className='me-2'>b. Marriage </b> - Any spouse to an Ibo person resident in County Donegal and its environ. <br/>
<b className='me-2'>c. The child/children of Igbo:</b> is/are eligible for membership upon the attainment of 18 years of age if such a person desires to join the association.<br/>
<i ><b className='me-2'>d. Honorary Title/Membership:</b> Any person conferred membership without their needing to have the necessary qualifications as above; usually because of their affiliation or inclination to the group.</i><br/><br/>



<strong><h6>Section III:</h6></strong>
<strong><h6>Active Membership:</h6></strong>
A member in good standing (i.e. pays dues and attends meetings regularly) who meets all the requirements to receive any benefits that the association may offer its members and have the right to vote and to be voted for.
Section IV<br/><br/>


<strong><h6>Section IV:</h6></strong>
<strong><h6>Honorable Membership</h6></strong>
<b className='me-2'>a.</b>  Any prospective Honorary Member must first be nominated by an Active Member<br/>
<b className='me-2'>b.</b>  Such nominations shall be made public notice and subject to a veto <br/>
<b className='me-2'>c.</b>  Any member exercising such veto must notify the Executive within 21 days from the date of notice<br/>
<b className='me-2'>d.</b>  Where no such veto exists, the nominee shall become subject to a probation period of three (3) years before an Honorary Membership can be granted
</div>            
</div>
  </Container>

  {    <hr className="horrizontal3" 
        style={{
        marginTop: '1.2rem', 
   
        borderTop: '1px solid rgba(0, 0, 0, 0.9)'}}
        />}
  <Container className='relative top-36'>
    <div className="row">
      <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 2:</b></u><br/><br/>

<strong> Registration and annual dues:</strong>

<b>Registration Fee:</b> All active members shall pay a one-time non-refundable registration fee of 15euros. This registration fee is applicable in whatever month in the year one becomes a member of the Association. <br/>
<b>Children and Dependents:</b> Children and dependents of active members under 18 years of age may become active members by registering upon attaining the age of 18 years. <br/>
<b>Annual Dues:</b> The annual dues of all members shall be 120 euros, and members have the option to pay it once or on a monthly installment of 10 euros each month of the year. <br/><br/>
<b>Inactive Members:</b> An inactive member shall be anyone who has not paid his/her dues for Six months within the current year. A lapse of membership in any year shall result in a reinstatement fee of 20 euros plus the outstanding monthly dues.
An active member of the association who wishes to maintain this status during a trip abroad lasting more than six months must inform the association of his intention to maintain an active member status during the period of his trip abroad.
</div>
</div>
  </Container>
  
  {    <hr className="horrizontal3" 
        style={{
        marginTop: '1.2rem', 
   
        borderTop: '1px solid rgba(0, 0, 0, 0.9)'}}
        />}

  <Container className='relative top-36'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 3:</b></u><br/><br/>



<p>
                <strong><h6>Officers of the association :</h6></strong>
                <span>The officers of the association shall consist of: </span>
                <div class="d-flex flex-column mx-2">
                <li class="d-flex align-items-center py-1">
                  <span class="bullet bg-black mx-2"></span> 
                  The Vice-President:
                </li>
                <li class="d-flex align-items-center py-1">
                  <span class="bullet bg-black mx-2"></span> 
                  The General Secretary :
                </li>
                <li class="d-flex align-items-center py-1">
                  <span class="bullet bg-black mx-2"></span>
                  The Treasurer:
                </li>
                <li class="d-flex align-items-center py-1">
                  <span class="bullet bg-black mx-2"></span> 
                  The financial Secretary :
                </li>
                <li class="d-flex align-items-center py-1">
                  <span class="bullet bg-black mx-2"></span>
                  The Provost:
                </li>
                
              </div>
            </p>
 

<strong> The President shall:</strong> <br/> 
<b>a.</b>  be the Chief Executive and Spokesperson for the association;<br/>
<b>b.</b>   on behalf the Cultural Group and with his executive team, organize meetings, conventions, and other activities deemed essential for the association's progress.<br/>
<b>c.</b>   Preside over all meetings and execute all policy decisions approved by the association.  <br/>
<b>d.</b>   Not vote except to cast the tie-breaker vote both in executive and General Assembly meetings; <br/>
<b>e.</b>	Convene the executive meeting at his discretion or whenever requested by half of the members of the Executive Committee;	<br/>
<b>f.</b>   Have the right to recommend to the general body the resignation of an official who is derelict in his duties;<br/>
<b>g.</b>   Sit on all committees as ex-officio;<br/><br/>

<b>The Vice-President shall:</b>
<br/>
<b>a.</b>  In the absence of the President assumes all the powers and duties of the President. <br/>
<b>b.</b>   work closely with and assist the President in the discharge of his/her duties <br/>
<b>c.</b> a.	work closely with and assist the President in the discharge of his/her duties<br/><br/>

<b>The General Secretary shall:</b>
<br/>
<b>a.</b>  be responsible for recording and reading the minutes of all general, emergency, and executive committee meetings,. <br/>
<b>b.</b>   be responsible for recording and reading the minutes of all general, emergency, and executive committee meetings, <br/>
<b>c.</b> keep an up-to-date record of every member of the association<br/><br/>
<b>The Vice-President shall:</b>
<br/>
<b>d.</b> Maintain custody of the secretarial equipment and stationery.. <br/>
<b>e.</b> Maintain custody of membership registration book<br/>
<b>f.</b> Shall send out notices of monthly/annual general meetings of the association.<br/><br/>

<b>The Treasurer shall:</b>
<br/>
<b>a.</b> deposits in the association's bank account all funds of the association within 48 hours of receipt,<br/>
<b>b.</b>deposits in the association's bank account all funds of the association within 48 hours of receipt,<br/>
<b>c.</b> pay the Cultural Group's bills vouched by the Financial Secretary and endorsed by the President;<br/>
<b>d.</b> be one of the signatories with that of the President, for withdrawing the association's funds,<br/>
<b>e.</b> have the power to demand and obtain the receipts of all the financial transactions of the association<br/>
<b>f.</b><br/> preside over the Budget Committee<br/>

<b>The financial Secretary shall:</b>
<br/>
<b>a.</b> keep books of account which shall show all financial transactions and all assets and liabilities of the association:<br/>
<b>b.</b> keep accurate records of receipts, bank transactions, incomes and expenditures made by the association<br/>
<b>c.</b> Send notices of annual dues to current regular members.<br/>
<b>d.</b> Collect registration fees, annual dues, levies, donations, and transfers same over to the Treasurer and obtain receipts. The transfers shall be completed at the end of each meeting<br/>
<b>e.</b> prepare and submit to the Audit Committee all financial records and books when required for audit, preside and/or submit to the General Assembly financial statements properly prepared to reflect the financial conditions of the cultural group quarterly:<br/><br/>

<b>The Publicity Secretary shall:</b>
<br/>
<b>a.</b> handle all the publicity needs of the association.<br/>
<b>b.</b> Clear all materials for publication with the Executive Committee before publishing, publicize and promote any material concerning the association.<br/>


<b>The Provost shall:</b>
<br/>
<b>a.</b> be responsible for enforcing all procedural rules during meetings<br/>
<b>b.</b> be responsible for enforcing all procedural rules during meetings<br/>
<b>c.</b> help the President in identifying and appointing speakers,<br/>
<b>d.</b> be responsible for maintenance of peace and order during meetings,<br/>
<b>e.</b> be responsible for collecting fines from defaulters during meetings and handing over same to the financial secretary,<br/>
<b>f.</b> Be responsible for maintaining peace and order and provide security during any social function and similar event of the association.

</div>
</div>
</Container>



<Container className='relative top-40'>
    <div className="row">

<div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 4:</b></u><br/><br/>

<b>Election of officers </b><br/>
<b>Section 1.</b><br/>

<b>a:</b>  Every officer shall be elected according to the rules prescribed here.
<br/>
<b>b :</b>  A candidate for election shall be nominated by a member and such a nomination shall be seconded by another member. 
<br/>
<b>c :</b>  There shall be different nominations and different balloting for each office.
<br/>
<b>d :</b> There shall be a maximum of three nominations for each office.
<br/>
<b>e :</b>  In all cases the nominated candidate with the highest number of votes shall be declared the winner.
<br/>
<b>f :</b>  A candidate shall be declared elected by acclamation where their nomination is not opposed by any other candidate. At this stage, he shall be declared unopposed by the returning officer.
<br/><br/>
<b>g :</b> Any nominee shall have the right to decline a nomination.
<b>h :</b>  Where there is a tie of votes, the tie shall be broken by repeating the vote.
<br/><br/>
<b>i :</b> Number of members present and voting shall be tallied with the total Votes cast.
<b>j :</b> However, a quorum shall never be less than 1/4 of the total number of active members including 3 executive committee members of the cultural group,
<br/>
<b>k :</b>  Nominations to offices shall take place on the day of the election
<br/><br/>
<b>l :</b> Elections shall be held in January of the election year,
<b>m :</b> The general meeting will appoint an electoral committee of three members
<b>n :</b> No voting by proxy or absentee ballot shall be permitted.<br/><br/>



<b>Section II</b><br/>
<b>Eligibility.</b><br/>
<b>a :</b> Only members who have satisfied their financial obligations to the association shall be eligible to run for office, to vote and be voted for.
<br/>
<b>b :</b>  A member who is on probation shall not be eligible to run for an office.
<br/>
<b>c :</b> To be eligible to run for an office, a member shall have maintained at
<br/>
<b>d :</b>  Least 12-month membership in good standing in the Cultural Group and attend meetings regularly.

</div>
</div>
</Container>


<Container className='relative 100 'style={{marginBottom:'2rem', marginTop:'12rem',}}>
<div className="row" >
<div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 5:</b></u><br/><br/>

<b> Section 1.</b><br/>
<b>Terms of office</b><br/>

<b>a:</b> Officers shall be elected for a term of two years. 
<br/>
<b>b :</b> New officers shall assume office immediately after a general election.
<br/>
<b>c :</b> A member who holds one office for two consecutive terms (four years) shall no longer contest for or be elected to the same office. They shall, however, be eligible for another office.
<br/><br/>
<b>d :</b> The executive shall complete handover to the newly elected executives within a outgoing month following the election of the new executive,<br/>
<b>e :</b> Notwithstanding the Provision of 90 in this section, an Officer who has been elected for two terms of office for a particular position can be reelected to the same office after an intervening period of one year.
<br/><br/>



<b>Section II</b><br/>
<b>Income and Property.</b><br/>
<main className='leads'>The income and property of the trust/body shall be applied solely towards the promotion of main object(s) as set forth in this Deed of Trust /Constitution / Rules.  No portion of the trust/body’s income and property shall be paid or transferred directly or indirectly by way of dividend, bonus or otherwise howsoever by way of profit to members of the trust/body.  No charity trustee* shall be appointed to any office of the trust/body paid by salary or fees, or receive any remuneration or other benefit in money or money’s worth from the trust/body.  However, nothing shall prevent any payment in good faith by the trust/body of:</main><br/>

<b>a :</b> reasonable and proper remuneration to any member or servant of the trust/body (not being a charity trustee) for any services rendered to the trust/body;
<br/>
<b>b:</b>   interest at a rate not exceeding 1% above the Euro Interbank Offered Rate (Euro) per annum on money lent by charity trustees or other members of the trust/body to the trust/body;
<br/>
<b>c:</b>    reasonable and proper rent for premises demised and let by any member of the trust/body (including any charity trustee) to the trust/body;<br/>
<b>d:</b>     fees, remuneration or other benefit in money or money’s worth to any Company of which a charity trustee may be a member holding not more than one hundredth part of the issued capital of such Company;<br/>
<b>e:   </b> Nothing shall prevent any payment by the trust/body to a person pursuant to an agreement entered into in compliance with section 89 of the Charities Act, 2009 (as for the time being amended, extended or replaced). 
(Charity trustee as defined by section 2(1) of the Charities Act, 2009)
</div>
</div>
  </Container>


  <Container className='relative top-5'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 6:</b></u><br/><br/>

<b>Vacancy and resignation :</b><br/>

<b>a:</b>  Any officer may resign their post in writing to the President/Executive Committee.
<br/>
<b>b:</b> Where the office to the President becomes vacant, the Vice-President immediately becomes the President.
<br/>
<b>c:</b> The President may resign by submitting his resignation to the cultural group through the general secretary. 
<b>d:</b> If the General Secretary resigns office, the Financial Secretary will replace him.
<b>e:</b> In all other cases, the vacancy shall be filled during a meeting following such resignation provided that the circular calling for such meeting stipulates that such a vacancy shall be filled, and there is, at least, fourteen days’ notice to that effect.
<br/><br/>


</div>
    </div>
  </Container>


  <Container className='relative top-8'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 7:</b></u><br/><br/>

<b>Committees of the association :</b><br/>
<article>The association shall have two types of committees:</article><br/>
<titl><b>Section 1</b></titl><br/>
<b>Standing Committees </b><br/>


<b>a:</b>  Any officer may resign their post in writing to the President/Executive Committee.
<br/>
<ul>
<li className='li-alpha '> The President:</li>
<li className='li-alpha '> The Vice-President:</li>
<li className='li-alpha '> The General Secretary :</li>
</ul>
<br/>

<b>Section II </b>
<header>Ad Hoc or Emergency Committee:  Ad hoc committees shall be created as the needs arise, including the following: </header><br/>

<header><b>The Audit Committee shall:</b></header>

<ul>
<li className='li-circle '>act as the association's auditors</li>     
<li className='li-circle'>verify the accounting records by checking against the original documents giving rise to the transactions that are recorded</li>     
<li className='li-circle'>	verify bookkeeping procedures of the association</li>     
<li className='li-circle'>	confirm by direct inquiry to creditors and debtors the balances due them or owned by them</li>     
</ul>
<header><b>The Election Committee shall:</b></header>

<ul>
<li className='li-circle'>consist of three members appointed by association to conduct the elections according to the procedures set up in the constitution.
</li>     
</ul>
</div>
</div>
  </Container>


  <Container className='relative top-16'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 8:</b></u>
<br/><br/>
<b>Meetings</b><br/>

<b>a:</b>  The time and place for the meetings shall be arranged by the President and the General Secretary. (Except for committee meetings that shall be at the time and place as each committee deems necessary.)
<br/>
<b>b:</b> The President and Provost shall have the responsibility to recognize speakers during meetings.
<br/>
<b>c:</b>The President shall call an emergency meeting whenever necessary.
<br/>
<b>d:</b> The President shall call an emergency meeting whenever necessary.
<br/><br/>
<b>e:</b> There shall be at least one week notice through circulars for any general meetings.<br/><br/>

<b>Section I: </b><br/>
<b>Types of Meetings are not limited to, but may include:</b>
<ul>
<li className='li-alpha'>The General Meetings </li>
<li className='li-alpha'>Executive Board Meetings </li>
<li className='li-alpha'>Committee Meetings </li>
<li className='li-alpha'>Emergency or Special Meetings </li>
<li className='li-alpha'>Annual General Meeting</li>
</ul>
<br/>
<b>Section II: </b><br/>
<article>
Notice of Meetings Emergency meetings whenever necessary may be called via the telephone/text messages. The notice of the association meeting to the members shall be the responsibility of the General Secretary at the request of the President. The notice of the Executive Board meetings shall be the responsibility of the President - The notices of the Committee meetings shall be the responsibility of the committee chairperson of the recording secretary of the committee, if one has been appointed.
</article>
<br/>

<b>Section III: </b><br></br>
<article>
<b>General Meetings:</b>An agenda shall be established and made available before each meeting. Any member desiring to place a new item on the floor must first submit the item in writing to the President prior to the beginning of the meeting.
Section IV: Special Meetings Special meetings shall be used to respond to emergencies or special needs. Special meetings may be called by the President or Executive Committee and all the members must be notified. Notice for the special meetings shall state the purpose for which such meetings are called, and no other business shall be acted upon at said meetings.

</article><br/>

<b>Section IV: </b><br></br>
<article>
Attendance:  Attendance at regular meetings is mandatory for all Executive Committee members. No member of the Executive Board may serve as a proxy for an absent member. Any Executive member missing three (3) consecutive regular meetings without good reason, in a calendar year, may be asked to vacate that office.
All members are encouraged to attend meetings regularly in order to be part of the decision making body of the Association and also to receive membership benefits. The Association shall decide the penalty fee for late attendance of meetings
</article>
</div>
 </div>
  </Container>


  <Container className='relative top-20'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 9:</b></u><br/><br/>

<b>Quorum</b><br/>
<title>The quorum for meetings shall apply in all cases only if all members involved have been duly notified:</title>
<article>
   <b className='pr-2'>a.</b>    one quarter (1/4) of the active members, shall form the quorum in a general meeting
   <br/>  
   <b className='pr-2'>b.</b>   on emergency meetings, the quorum requirement shall not apply,
   <br/>       
   <b className='pr-2'>c.</b>  on emergency situations, the members present constitute the quorum;
   <b className='pr-2'>c.</b>  on emergency situations, the members present constitute the quorum;
   <br/>     
   <b className='pr-2'>d.</b>  the quorum for the Executive members' meeting shall be three (3), 
   <br/>       
   <b className='pr-2'>e.</b>	The quorum for the committee meetings shall be three (3).
   
</article>
</div>

    </div>
  </Container>

  <Container className='relative top-24'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 10:</b></u><br/><br/>

<b>Finance</b>

<title><b>Section l</b></title><br/>
<header>The finances of the Association shall be derived from the following sources: Annual dues, fees, levies, fines donations, fund raising activities</header>

<ul>
<li className='li-alpha'>Annual Dues. Any person becoming a member at any time during the year shall pay the full registration fee of 15eurs and monthly dues of 5euros.</li>
<li className='li-alpha'>Levies. As the need arises, the Association shall solicit contributions by a majority vote of the members.</li>
<li className='li-alpha'>Fund Raising Activities. Shall be organized by the Association or on behalf of the Association to raise necessary funds as the need arises </li>
<li className='li-alpha'>Donations. Donations shall be solicited from members as the need arises</li>

</ul>


<header><b>Section II</b></header>

<article>
Delinquent Receivables Delinquency in payment(s) of Association's dues and fees or levies will affect the status of active membership, rights and privileges accorded by this association to each family or individual members of this Cultural Group. A member shall be regarded as having become inactive if monthly dues are unpaid for 3 months.      
</article>
<title><b>Section III</b></title>
<br/>
<header><b>Banking and Borrowing Power</b></header>
<ul>
<li className='li-alpha bold'>Regular current and or savings account shall be opened at such bank(s) as the General Assembly shall determine or dictate.</li>
<li className='li-alpha'> Funds collected, raised or donations received at each meeting shall be deposited by the association's treasurer into the association bank account within 2 working days or 48 hours following such activities, i.e. meeting, fund raising, etc.</li>
<li className='li-alpha'> The signatories to association bank account shall be those of the association's president or vice president and the treasurer shall be required for withdrawal of funds.</li>
<li className='li-alpha'>The financial secretary shall give account of the association's funds on a quarterly basis</li>
<li className='li-alpha'>The fiscal year for the association shall start on the first day of January and end on the 31st day of December. The yearly audit report of this association's account shall be issued at the 2nd monthly meeting of the association following the end of the last fiscal year. Every expenditure above one hundred and fifty euros (100.00) shall receive the approval of the association at the general meeting before it is spent.</li>
<li className='li-alpha'>In event of borrowing money from any financial institution, the president, secretary, financial secretary and treasurer shall act on behalf of the association and be signatories to any decision reached as approved by 2/3 majority</li>
<li className='li-alpha'>Expenditure of the sum of hundred and 100 euros or less may be approved or authorized by the Executive Committee of the association.</li>
     
</ul>
</div>
</div>
  </Container>

  <Container className='relative top-24'>
    <div className="row">

    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 11:</b></u><br/><br/>

<b>Expenditures and Withdrawals</b>
<br/>
<ul>
<li className='li-alpha'>All monies shall be duly accounted for by the officer or individual involved.</li>      
<li className='li-alpha'>All valid receipts, cheques, or liability must be in order for all disbursements.</li>      
<li className='li-alpha'>Cheques for withdrawal of monies from the association's bank account shall be endorsed by the President and the Treasurer.</li>      
</ul>
</div>
      </div>
      </Container>
  <Container className='relative top-24'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 12:</b></u><br/><br/>

<header><b>Rights, privileges and benefits </b></header>
<header><b>Section I.</b></header>
<br/>
<b className='pr-2'>a:</b> All registered active members of the Group are accorded full rights and privileges of the association.
<br/>
<b className='pr-2'>b:</b>This accordance of rights and privileges are subordinate to other provisions of this constitution which may for some reasons provide otherwise, 
<br/>
<b className='pr-2'>c:</b>Membership privileges shall be maintained under the following conditions by a registered member in good standing who is unable to pay his dues: 
<br/>
<ol>
   <li className='li-number'>Association shall temporarily postpone the collection of the annual dues for up to 3 months or until the member is financially able to pay, whichever comes first.</li>     
   <li className='li-number'>The member shall apply to the President for consideration by the Executive Committee under this provision and express his desire to remain the Association active member during the period in which he is unable to pay dues. </li>     
   <li className='li-number'>The member shall have full membership privileges during this period.</li>     
   <li className='li-number'> This provision applies to annual dues and levies only. It does not apply to registration dues and other voluntary contributions made by members toward specific purposes. </li>     
   <li className='li-number'>A member may use this privilege for not more than 1 calendar year at a time -</li>     
</ol>

<header><b>Section II. </b></header>
<header><b>Privileges include:</b></header>

<ul>
<li className='li-alpha'>the right to vote and be voted for</li>
<li className='li-alpha'>the right to hold office</li>
<li className='li-alpha'>the right to represent the Association in a conference, if asked to do so</li>
<li className='li-alpha'>the right to organize and make any worthwhile contribution to the Association approved by the general assembly</li>
<li className='li-alpha'>the right for the members of the association to attend any ceremony (naming, etc.) when a member officially informs the association of such event, and the association shall send a congratulation card</li>
<li className='li-alpha'>the right to give a send-off party when a member officially informs the Cultural Group that he is finally leaving Ireland to relocate</li>
<li className='li-alpha'><b>Marriage/Wedding/Illness:</b> A duly registered active member shall be entitled to the sum of 200suros from the Association when he is having a wedding. All members are encouraged to attend and support such ceremony. If a member is hospitalized, the Group shall send a get well card; in addition, members are encouraged to visit such a person</li>
<li className='li-alpha'>Death Benefits: When a member is deceased and the Association is duly notified, the Association shall organize and pay for a wake keeping in his honour. The Association shall delegate two representatives to assist in the funeral arrangements. The association will request for voluntary contributions by members towards assisting the bereaved family in funeral arrangements</li>
<li className='li-alpha'><b>Death of Member(s) parent:</b> When officially notified, a wake-keeping shall be organized by the Association on behalf of member(s) who lost their parent</li>
<li className='li-alpha'>Members will be encouraged to make monetary donations. All monies collected shall be given to the member(s)</li>
<li className='li-alpha'><b>Death of A Child: </b>When officially notified, the Association shall participate in funeral arrangements as in subsection h above. Members will be encouraged to make voluntary </li>
<li className='li-alpha'>Problem with the Law: The Cultural Group shall evaluate each situation and assist the member as necessary.</li>
</ul>

<header><b>Section III. </b></header>
<main>The send-off party as stated in Section IIf above, shall include a gift valued at no less than 100 euros. Only the member who has maintained up to one year of membership and has paid up all his dues and/or levy to the Cultural Group shall qualify for the send-off party.    
</main><br/>

<header><b>Section IV.</b></header>
<ul>
<li className='li-alpha'>When more than one member is leaving Ireland or relocating at the same period, the Cultural Group shall at its convenience, organize only one send-off party in their honour.</li>
<li className='li-alpha'>Any member defaulting in this contribution shall have their send-off right amount debited to his account with the Cultural Group, and this must be paid along with the annual dues for the year in which the contribution was levied.</li>
</ul>
</div>

      </div>
      </Container>
  <Container className='relative top-24'>
    <div className="row">

    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 13:</b></u><br/><br/>

<b>Settlement of outstanding debts to the group</b><br/>
<ul>
<li className='li-alpha'>No member shall expect to receive separate notices for non-payment of approved Association fees, dues, levies or calls for donations.</li>
<li className='li-alpha'>The fiscal year for the Association shall start on the first day of January and end on the 31st day of December of each year.</li>
<li className='li-alpha'>Balancing of books for the previous fiscal year shall be done no later than 31st day of January of the New Year.</li>
</ul>
</div>
      </div>
      </Container>
  <Container className='relative top-24'>
    <div className="row">

    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 14:</b></u><br/><br/>

<main><b>Disciplines, dismissals and anti-cultural group activity:</b> Every member of the Association is subject to the Group's disciplines as determined by the Executive committee. No financial refund shall be awarded in the event of the termination/resignation of membership.</main><br/>

<b>Section I </b>  
<br/>
<b>Disciplines: </b> .
<br/>
<ol>
<li className='li-number'>Any member who exhibits a disorderly conduct shall be fined 20 euros if found guilty after a hearing in a general meeting.</li>
<li className='li-number'>Late comers shall pay a fine of 2euros after a 15 minutes grace period,</li>
<li className='li-number'>Any member found disruptive in any meeting shall be subject to a fine of two euros (2.00)</li>
<li className='li-number'>Any member that fails to attend a meeting without giving reasonable excuse prior to meeting shall pay a fine of 5 euros.</li>
</ol><br/>
<header><b>Section II. </b></header>
<header><b>Dismissals and Conditions under which Membership Ceases</b>
</header>

<ul>
        <li className='li-alpha>'>Any member found fighting or who inflicts a physical abuse on another in any meeting or social function put together or sponsored by the Cultural Group shall be suspended for a period of four (4) months and pay a penalty of 100 euros.</li>
        <li className='li-alpha>'>Any member found with weapons, or illegal drugs in our meetings or social functions put together or sponsored by the association shall be dismissed.</li>
        <li className='li-alpha>'>If a member fails to appear for a hearing without official excuse, except Where there is an unavoidable circumstance, he shall be probated for a period of sixty (60) days.</li>
        <li className='li-alpha>'>Failure to appear for a hearing while on probation shall result in a dismissal by a majority vote.</li>
        <li className='li-alpha>'>Any member on probation shall have their rights and privileges suspended, and the rights and privileges can only be reactivated on the successful completion of the probation.</li>
        <li className='li-alpha>'>A member who is on probation and who breaks another rule of the association shall have his membership revoked if found guilty of the second offence.</li>
        <li className='li-alpha>'>A revoked member can apply for re-admission and if their application is approved by a majority vote, he shall pay a reinstatement fee of 20 euros plus all outstanding dues and levies</li>
        <li className='li-alpha>'>Any member that fails to attend 3 consecutive meetings in one calendar year without giving 24 hours’ notice in each will become inactive members.</li>
        <li className='li-alpha>'>Determination of guilt and dismissals shall be by a majority vote of the members present,</li>
</ul>
<br/>
<header><b>Section III</b></header>
<header><b>Anti-Group Activities</b></header>
<ul>
        <li className='li-alpha'>Any activity which the Group considers detrimental to the progress and operation of the Group shall be anti-Cultural Group; </li>
        <li className='li-alpha'>	Determination that any activity is anti-Group shall be by a two thirds majority vote of the members present at a general meeting </li>
        <li className='li-alpha'>Any member found guilty of anti-Group activities after probation shall be subject to immediate dismissal of the member by a two thirds majority vote in the General Assembly.</li>
</ul>

</div>

      </div>
      </Container>
  <Container className='relative top-24'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 15:</b></u><br/><br/>

<header><b>Censure or judgment</b></header>
<ul>
<li className='li-alpha'>Any elected or appointed executive and/or member is subjected to a vote of censure by members of the association,</li>
<li className='li-alpha'>There shall be one-quarter (2/3) of members present at a general meeting to approve a disciplinary action against such an executive and/or member.</li>
<li className='li-alpha'>Conditions for censure of any of the executives and/or members of the Cultural Group shall arise from any of the following: Corruption, inefficiency, fighting and laxity on duty, embezzlement and misuse of power.</li>
<li className='li-alpha'>Any allegation against any executive and/or member shall be made in writing. If such an allegation has a foundation which shall be determined by the General Assembly an investigation shall be conducted by a special committee appointed by the general house. The committee shall report their findings within a given time to the General Assembly. The verdict of guilty or not guilty shall be determined by a majority of members present at the meeting.</li>
<li className='li-alpha'>An executive and/or member under investigation shall step down for the period of the investigation.</li>
<li className='li-alpha'>If an executive and/or member is guilty of embezzlement of the association's funds, he/she shall be made to pay back the money or material embezzled either through out of court settlement or by a legal action in the courts</li>
<li className='li-alpha'>If any executive and/or member is guilty of any of the offences mentioned above, he may be impeached, reprimanded, probated or dismissed from the association. The punishment shall depend on the magnitude of the offence and shall be determined by the General Assembly by a majority vote.</li>
<li className='li-alpha'>If the executive is found not guilty, he shall be reinstated.</li>
<li className='li-alpha'>Members should not take each other to Court without consulting the Group.</li>
</ul>
</div>


      </div>
      </Container>
  <Container className='relative top-24'>
    <div className="row">

    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 16:</b></u><br/><br/>

<b>Affiliation with other sister associations</b><br/>

<ul>
        <li className='li-alpha'>This association shall cooperate with other sister associations in IRELAND to promote the general wellbeing of the Cultural Group.</li>
        <li className='li-alpha'>This association, under the approval of the majority vote of the General Assembly, shall be affiliated with other ethnic groups in our region with similar goals.</li>
        <li className='li-alpha'>This association shall engage only in the activities authorized by this bylaw,</li>
        <li className='li-alpha'>While this ASSOCIATION shall co-operate with other sister associations elsewhere, it shall conduct its affairs as permitted by the laws of Ireland</li>
</ul>
</div>

      </div>
      </Container>
  <Container className='relative top-24'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 17:</b></u><br/><br/>

<header><b>Use of Membership Lists:</b>Membership lists may only be used to conduct official association business and for communication among its members. Use of membership lists by non-members shall be prohibited, except as approved by the ASSOCIATION.</header>
<header><b>Members and the constitution:</b>These laws shall be binding on all members. While it is subject to amendments as provided herein, these laws, or any parts thereof, shall not be suspended.</header>
<header><b>Protection of Members and their Family:</b> Each member shall be encouraged to carry suitable life, health, property and automobile liability insurance, at their own expense.</header>



</div>


      </div>
      </Container>
  <Container className='relative top-28'>
    <div className="row">
    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 18:</b></u><br/><br/>

<b>Dissolution/Winding – up of the body</b><br/>
<p>In the event that dissolution of the ASSOCIATION becomes necessary, a decision shall be made by the simple majority vote of active members, at a special meeting called by the President. The dissolution process of the association shall be completed by the Executive Committee in accordance with the state and provincial rules and regulations.</p>
<p>If upon the winding up or dissolution of the trust/body there remains, after satisfaction of all debts and liabilities, any property whatsoever, it shall not be paid to or distributed among the members of the trust/body. Instead, such property shall be given or transferred to some other charitable institution or institutions having main objects similar to the main objects of the trust/body.  The institution(s) to which the property is to be given or transferred shall prohibit the distribution of their income and property among their members to an extent at least as great as is imposed on the trust/body under or by virtue of Clause hereof. </p>
<p>Members of the group shall select the relevant institution(s) at or before the time of dissolution, and if and so far as effect cannot be given to such provisions, then the property shall be given or transferred to some charitable object with the agreement of the Charities Regulator. </p>
<p>Final accounts will be prepared and submitted that will include a section that identifies and values any assets transferred along with the details of the recipients and the terms of the transfer.</p>

</div>
</div>
 </Container>

  <Container className='relative top-28'>
    <div className="row">

    <div className='constitution-table' style={{maxWidth:'45rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 19:</b></u><br/><br/>

<b>Constitutional amendments </b><br/>
<header>New amendment proposal must be submitted in writing to the Provost and shall reach the ASSOCIATION at the next meeting. </header>
 <ul>
        <li className='li-alpha'>Such amendment shall become a provisional law by a 75% approval vote of those attending a meeting.</li>
        <li className='li-alpha'>Such provision in (a) above, if ratified, shall become effective immediately,</li>
        <li className='li-alpha'>The physical (written) document will be updated once every two years to include all provisional law changes.</li>
 </ul>

</div>

      </div>
      </Container>
  <Container className='relative top-28'>
    <div className="row">

    <div className='constitution-table' style={{maxWidth:'45rem', paddingBottom: '2rem'}}>
<u><b style={{fontSize:'1.2rem', fontWeight:'700'}}> ARTICLE 20:</b></u><br/><br/>

<b>Philanthropic activities</b><br/>
<article>In furtherance of the Cultural Group's purpose of promoting the social, educational, cultural and civic well-being of its members, the association will engage itself in the philanthropic activities listed in this section from time to time.</article>

<ul>
        <li className='li-alpha'>The group MAY award scholarships subject to the availability of funds.</li>
        <li className='li-alpha'>The association MAY make monetary contributions to organization’s caring and supporting the less privileged members of our society either here in IRELAND or in Nigeria.</li>
        <li className='li-alpha'>The Benefits committee of the association will determine individuals that are eligible for scholarships and the organization to which monetary contributions shall be made to.</li>
</ul>

</div>
</div>
</Container>
  
</div>

  )
}

export default Constitution
   
  
 